(ns ui.editor2.recent)

(def local-storage-key
  "storrito:editor2:recent")

(def default-recent
  {:version 1
   :giphy []
   :stickers []
   :images []
   :mentions []
   :hashtags []
   :locations []})

(defn local-storage
  []
  (try
    (.-localStorage js/window)
    (catch :default _e
      nil)))

(defn normalize
  [recent]
  (merge default-recent
         (when (map? recent)
           recent)))

(defn read-editor2-recent
  []
  (try
    (if-let [storage (local-storage)]
      (if-let [value (.getItem storage
                               local-storage-key)]
        (normalize
          (js->clj (js/JSON.parse value)
                   :keywordize-keys true))
        default-recent)
      default-recent)
    (catch :default e
      (js/console.warn "Failed to read editor2 recent state from localStorage" e)
      default-recent)))

(defn write-editor2-recent!
  [recent]
  (try
    (when-let [storage (local-storage)]
      (.setItem storage
                local-storage-key
                (js/JSON.stringify
                  (clj->js (normalize recent)))))
    (catch :default e
      (js/console.warn "Failed to write editor2 recent state to localStorage" e))))

(defn put-latest-entry
  [entries entry key-f max-entries]
  (->> entries
       (remove #(= (key-f entry)
                   (key-f %)))
       (cons entry)
       (take max-entries)
       (vec)))
